import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-cda28f16"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_createTextVNode("关闭");

import { ref, computed, watch } from 'vue';
import { getAttractApplyDetail } from '@/request';
export default {
  name: 'ApplyDetailModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    id: {
      type: [String, Number],
      default: -1
    }
  },
  emits: ['update:modelValue'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const detail = ref({});
    watch(() => props.modelValue, newVal => {
      if (!newVal) {
        detail.value = {};
      } else {
        getAttractApplyDetail({
          applyId: props.id,
          __warn: true
        }).then(data => {
          if (data.success) {
            detail.value = data.data;
          }
        });
      }
    });
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const scroll = ref();
    return (_ctx, _cache) => {
      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_scrollbar = _resolveComponent("el-scrollbar");

      const _component_AddTeamModal = _resolveComponent("AddTeamModal");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "查看详情",
        top: "30px",
        width: "80%"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
          style: {
            "padding": "10px"
          },
          ref_key: "scroll",
          ref: scroll
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form, {
            align: "left",
            "label-width": "100px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_row, null, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "申请品种:"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(detail.value.prodName), 1)]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "规格:"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(detail.value.prodSpecification), 1)]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_row, null, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "申请人姓名:"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(detail.value.linkMan), 1)]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "登录账号:"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(detail.value.loginName), 1)]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_row, null, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "联系方式: "
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(detail.value.linkPhone), 1)]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "业务区域: "
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(detail.value.userBusinessAreas), 1)]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_row, null, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "常驻地:"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(detail.value.userLocationAreas), 1)]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "身份:"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(detail.value.userTypeName), 1)]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_row, null, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "主业务渠道:"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(detail.value.userChannels), 1)]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "适应科室:"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(detail.value.userDepartments), 1)]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_row, null, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "产品偏好:"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(detail.value.userProdCategories), 1)]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "代理区域"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(detail.value.agentAreaCodes), 1)]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 512), _createVNode(_component_AddTeamModal, {
          modelValue: _ctx.showAddProductModal,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.showAddProductModal = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};